import { useEffect, useState } from "react";
import type { ProductionRun } from "./models";
import { productionGateway } from "./production-gateway";
import { decodeCasePackagingConfirmation, type CasePackagingConfirmation } from "./case-packaging";

export function useCasePackaging(run: ProductionRun | null, terminalCode: string, enabled: boolean) {
  const runId = run?.id ?? null;
  const runStatus = run?.status;
  const [state, setState] = useState<{ key: string; value: CasePackagingConfirmation | null; loading: boolean; error: string | null }>({ key: "", value: null, loading: false, error: null });
  const [attempt, setAttempt] = useState(0);
  const key = `${terminalCode}:${runId ?? ""}`;
  useEffect(() => {
    if (!enabled || !runId) return;
    const controller = new AbortController();
    setState({ key, value: null, loading: true, error: null });
    void productionGateway.casePackaging(runId, terminalCode, controller.signal).then((raw) => {
      if (!controller.signal.aborted) setState({ key, value: decodeCasePackagingConfirmation(raw), loading: false, error: null });
    }).catch((error: unknown) => {
      if (!controller.signal.aborted) setState({ key, value: null, loading: false, error: error instanceof Error ? error.message : "Koli içeriği doğrulanamadı." });
    });
    return () => controller.abort();
  }, [enabled, key, runId, runStatus, terminalCode, attempt]);
  const scoped = state.key === key ? state : { value: null, loading: enabled, error: null };
  const value = scoped.value?.runId === runId && scoped.value.productCode === run?.productCode ? scoped.value : null;
  return { value, loading: scoped.loading, error: scoped.error, retry: () => setAttempt((n) => n + 1),
    accept: (confirmation: CasePackagingConfirmation) => {
      if (confirmation.runId !== runId || confirmation.productCode !== run?.productCode) throw new Error("Koli içeriği başka bir işe ait.");
      setState({ key, value: confirmation, loading: false, error: null });
    } };
}
